import classes from './radio.module.css'

const Radio = {
  classNames: {
    label: classes.label,
  },
}

export default Radio
